import Component from "@ember/component"
import { action, computed, get, set } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { inject as service } from "@ember/service"
import { isNone } from "@ember/utils"
import { tracked } from "tracked-built-ins"

class ObjectPromiseProxy extends ObjectProxy.extend(PromiseProxyMixin) {}

export default class AdminSkeleton extends Component {
  @service("ember-store")
  store

  @service
  session

  declare model

  @tracked currentVersion = "master"

  @computed("currentVersion", "model.id", "model.type")
  get modelToStringify() {
    let version = get(this, "currentVersion")
    let type = this.model.type
    let id = this.model.id
    let promise
    if (isNone(type) || isNone(id)) return null
    if (version === "master") {
      promise = get(this, "store")
        .find(type, id)
        .then((doc) => doc)
    } else {
      promise = get(this, "store")
        .find("document-version", `${type}:${id}:${version}`)
        .then((doc) => {
          return doc ? doc.attributes.originalDocument : null
        })
    }
    return ObjectPromiseProxy.create({ promise: promise })
  }

  @action
  selectVersion(version) {
    set(this, "currentVersion", version)
  }

  @action
  stopImpersonating() {
    get(this, "session").stopImpersonating()
    window.location.reload()
  }
}
